import { BaseSliceController } from '@Base/slices/slices.base';
import { AttendanceReportRequester } from '../Services/AttendanceReport.requester';
import { AttendanceCheckinRow } from '../Types/AttendanceReport.types';

export class AttendanceReportSlice extends BaseSliceController<
	AttendanceCheckinRow,
	'AttendanceReport',
	AttendanceCheckinRow
> {
	static instance: AttendanceReportSlice;

	static getInstance() {
		if (!AttendanceReportSlice.instance) {
			AttendanceReportSlice.instance = new AttendanceReportSlice();
		}
		return AttendanceReportSlice.instance;
	}

	constructor() {
		super('AttendanceReport', AttendanceReportRequester.getInstance());
	}
}

export const { attendanceReportGetAll, attendanceReportExportData } =
	AttendanceReportSlice.getInstance().getActions();
